import { Input } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useGetData from "../../api/useGetData";
import { Pagination } from "../../common/Pagination";
import BookingCard from "../../components/MyBookings/BookingCard";

/**
 * The entry point to the booking page, a page that lists the user's bookings history.
 *
 * @returns {JSX.Element}
 */

export default function MyBooking() {
  const [searchValue, setSearchValue] = useState("");
  const user = useSelector((state) => state.authData.user);
  const { data, getData } = useGetData({
    route: user?.hasOwnProperty("agent")
      ? "api/method/airport_transport.api.agent.get_bookings"
      : "api/method/airport_transport.api.bookings.my_bookings",
    params: {},
  });

  const perPage = 9;
  const [currentPage, setCurrentPage] = useState(1);
  const filterData = () => {
    return searchValue
      ? data.filter((booking) =>
          Object.values(booking).join(" ").toLowerCase().includes(searchValue)
        )
      : data;
  };
  const filteredData = filterData();
  const totalPages = Math.ceil(filteredData.length / perPage);
  const lastIndex = currentPage * perPage;
  const firstIndex = lastIndex - perPage;
  const currentData = filteredData.slice(firstIndex, lastIndex);
  const [t, i18n] = useTranslation("global");

  useEffect(() => {
    getData({ params: {} });
  }, [t, i18n]);

  return (
    <div className="md:px-14 px-7 py-7 bg-background_steel_blue">
      <Input
        name="search"
        placeholder={t("my_booking.search_bookings_text")}
        className="mb-5"
        value={searchValue}
        onChange={(e) => {
          setSearchValue(e.target.value);
          if (currentPage !== 1) {
            setCurrentPage(1);
          }
        }}
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-x-10 gap-y-4">
        {currentData.map((booking) => (
          <BookingCard key={booking.name} booking={booking} />
        ))}
      </div>
      {currentData.length === 0 && (
        <p className="text-text_white text-center mt-10 mb-10">
          {t("my_booking.no_booking_text")}
        </p>
      )}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </div>
  );
}
